import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './styles/theme.css';

import { AuthProvider, useAuth } from './context/AuthContext';
import { FinancialYearProvider } from './context/FinancialYearContext';
import Layout from './components/Layout/Layout';
import Login from './components/Auth/Login';
import Dashboard from './components/Dashboard/Dashboard';
import ReferenceLinks from './components/Dashboard/ReferenceLinks';
import CompanyManagement from './components/Company/CompanyManagement';
import CommercialList from './components/Documents/CommercialList';
import CommercialForm from './components/Documents/CommercialForm';
import ProformaForm from './components/Documents/ProformaForm';
import ProformaList from './components/Documents/ProformaList';
import ContactManagement from './components/Contacts/ContactManagement';
import BuyerManagement from './components/Buyers/BuyerManagement';
import UserManagement from './components/Users/UserManagement';
import RolePermissionManagement from './components/Users/RolePermissionManagement';
import Settings from './components/Settings/Settings';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="loading-container" style={{ minHeight: '100vh' }}>
        <div className="spinner" />
        <span>Loading...</span>
      </div>
    );
  }

  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

function App() {
  return (
    <AuthProvider>
      <FinancialYearProvider>
      <Router>
        <Routes>
          <Route path="/login" element={
            <PublicRoute><Login /></PublicRoute>
          } />

          <Route path="/" element={
            <ProtectedRoute><Layout /></ProtectedRoute>
          }>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="companies" element={<CompanyManagement />} />
            <Route path="commercial-invoices" element={<CommercialList />} />
            <Route path="commercial-invoices/new" element={<CommercialForm />} />
            <Route path="commercial-invoices/edit/:id" element={<CommercialForm />} />
            <Route path="proforma-invoices" element={<ProformaList />} />
            <Route path="proforma-invoices/new" element={<ProformaForm />} />
            <Route path="proforma-invoices/:id" element={<ProformaForm />} />
            <Route path="buyers" element={<BuyerManagement />} />
            <Route path="contacts" element={<ContactManagement />} />
            <Route path="users" element={<UserManagement />} />
            <Route path="roles-permissions" element={<RolePermissionManagement />} />
            <Route path="settings" element={<Settings />} />
            <Route path="references" element={<ReferenceLinks />} />
          </Route>

          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
      </FinancialYearProvider>

      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </AuthProvider>
  );
}

export default App;
